export const MODES = ['walkthrough', 'furnish_estate'] as const;
export type Mode = (typeof MODES)[number];

export const ASPECT_RATIOS = ['16:9', '9:16', '4:5'] as const;
export type AspectRatio = (typeof ASPECT_RATIOS)[number];

export const QUALITIES = ['720p', '1080p'] as const;
export type Quality = (typeof QUALITIES)[number];

export const IMAGE_TO_VIDEO_MAX_IMAGES = 5;

export const MODE_RULES: Record<
  Mode,
  {
    allowedRatios: AspectRatio[];
    minDuration: number;
    maxDuration: number;
    minImages: number;
    maxImages: number;
  }
> = {
  walkthrough: {
    allowedRatios: ['16:9', '9:16', '4:5'],
    minDuration: 3,
    maxDuration: 12,
    minImages: 1,
    maxImages: IMAGE_TO_VIDEO_MAX_IMAGES,
  },
  furnish_estate: {
    allowedRatios: ['16:9', '9:16', '4:5'],
    minDuration: 3,
    maxDuration: 12,
    minImages: 1,
    maxImages: IMAGE_TO_VIDEO_MAX_IMAGES,
  },
};
